import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/webshop")({
  beforeLoad: () => {
    throw redirect({ to: "/c" });
  },
  component: () => null,
});
